<template>
  <div>
    <b-modal v-model="showModal" hide-footer centered>
      <template #modal-title> پیام ها</template>
      <div class="d-flex flex-column justify-content-center align-items-center my-1">
        <p>
          شما
          {{ $store.state.appConfig.count }}
          پیام خوانده نشده دارید
          .
        </p>
 
        <b-button  variant="gradient-primary" @click="$router.push({name:'apps-email'})">
            
            مشاهده پیام
        </b-button>
      </div>
 
    </b-modal>
  </div>
</template>

<script>
import { BRow, BCol, BButton, BModal } from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,

    BModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },
  data() {
    return {
      amount: "",
      loading: false,
    };
  },
};
</script>
<style>
 .modal-header .close {
    margin: 0 !important;
}</style>
